/* 🤖 this file was generated by svg-to-ts */
export const matIconBrunchDining: {
  name: 'brunch-dining';
  data: string;
} = {
  name: 'brunch-dining',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 21.5c0 .28.22.5.49.5h13.02c.27 0 .49-.22.49-.5V20H2v1.5zM15.5 16H11v-2H7v2H2.5c-.28 0-.5.22-.5.5V18h14v-1.5c0-.28-.22-.5-.5-.5zm4.97-.55A5.796 5.796 0 0 0 22 11.51V2h-6v9.47c0 1.48.58 2.92 1.6 4l.4.42V22h4v-2h-2v-4.03l.47-.52zM18 4h2v4h-2V4zm1.03 10.07a3.893 3.893 0 0 1-1.03-2.6V10h2v1.51c0 .95-.34 1.85-.97 2.56z"/></svg>`
};
